import React, { useState } from 'react'
import { useApp } from '../../../context/AppProvider'
import { isEmpty } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import CanHelpMeItem from './CanHelpMeItem'

const CanHelpMe = ({ block }) => {
    const [openChildrens, setOpenChildrens] = useState(false)
    const { valueLocation } = useApp()
    const localSearchFormBlock = block?.childrens.filter(
        (child) => child.block === 'RechercheLocalForm'
    )

    return (
        <article className="baseocom-can-help-me-block">
            <div className="baseocom-title">
                {icon('help-me')}
                <h3>Qui peut m'aider ?</h3>
            </div>
            <p className="baseocom-introduction">
                Vous avez une question ? Vous souhaitez être accompagné(e) dans vos démarches ?
            </p>
            <div data-open={openChildrens} className="baseocom-container">
                <button onClick={() => setOpenChildrens(true)}>Trouver un interlocuteur</button>
            </div>
            <div data-open={openChildrens} className="baseocom-content-items">
                {isEmpty(localSearchFormBlock) ? (
                    <CanHelpMeItem block={block} />
                ) : (
                    <>
                        <Parser content_block={localSearchFormBlock} />
                        {!isEmpty(valueLocation) ? (
                            <CanHelpMeItem valueLocation={valueLocation} block={block} />
                        ) : null}
                    </>
                )}
            </div>
        </article>
    )
}

export default CanHelpMe
